import { render, staticRenderFns } from "./ItemNoSaleSaveLayout.vue?vue&type=template&id=0be1c05a&scoped=true"
import script from "./ItemNoSaleSaveLayout.vue?vue&type=script&lang=js"
export * from "./ItemNoSaleSaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1c05a",
  null
  
)

export default component.exports